import {Organisation, OrganisationDeploymentState} from '@cquential/api';

export default class DeploymentStateMapping {
    private static mapping: Record<string, Record<string, number>> = {};

    /**
     * @param organisation
     */
    public static getStateMapping(organisation: Organisation): Record<string, number> {
        if (!(organisation.id in DeploymentStateMapping.mapping)) {
            DeploymentStateMapping.calculate(organisation);
        }

        return DeploymentStateMapping.mapping[organisation.id];
    }

    private static calculate(organisation: Organisation): void {
        const states: Record<number, OrganisationDeploymentState> = organisation.organisationDeploymentStates;
        for (const deploymentStateId in states) {
            DeploymentStateMapping.mapping[organisation.id] ??= {};
            DeploymentStateMapping.mapping[organisation.id][states[deploymentStateId].id] = parseInt(deploymentStateId, 10);
        }
    }
}
